import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { Table, TableBody, TableCell, TableHead, TableRow, IconButton } from '@mui/material'
import { AUTHORITIES_JP } from 'config'

import type { AddUserPayload } from 'types'

type UITProps = {
  users2Add: AddUserPayload[]
  setUsers2Add: React.Dispatch<React.SetStateAction<AddUserPayload[]>>
}
export default function UsersImportTable({ users2Add, setUsers2Add }: UITProps) {
  return (
    <Table size="small" aria-label="a dense table">
      <TableHead data-testid="table-head-import-users">
        <TableRow sx={{ '& th': { backgroundColor: 'grey.200' } }}>
          <TableCell>名前</TableCell>
          <TableCell>ビジネスID</TableCell>
          <TableCell>権限</TableCell>
          <TableCell>グループ</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody data-testid="table-body-import-users">
        {users2Add.map((user) => (
          <Row
            key={user.email}
            user={user}
            onDelete={() => {
              setUsers2Add((users) => users.filter((x) => x.email !== user.email))
            }}
          />
        ))}
      </TableBody>
    </Table>
  )
}

interface RowProps {
  user: AddUserPayload
  onDelete: () => void
}
const Row = ({ user, onDelete }: RowProps) => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        {user.name}
      </TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>{AUTHORITIES_JP[user.authority]}</TableCell>
      <TableCell>{user.subGroups.join(', ')}</TableCell>
      <TableCell>
        <IconButton onClick={onDelete} size="small" aria-label="delete">
          <HighlightOffIcon sx={{ fontSize: 22 }} />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}
